'use client';

import IllustrationMotion from '@/features/empty-state/IllustrationMotion';
import {
  panelVariants,
  specRowVariants,
  staggerContainer,
} from '@/features/product/motion/productMotion';
import { motion, useReducedMotion } from 'framer-motion';

function readMessage(messages, path, fallback = '') {
  const resolved = path
    .split('.')
    .reduce((current, segment) => current?.[segment], messages);

  return typeof resolved === 'string' ? resolved : fallback;
}

export default function SpecsPlaceholder({ messages = {} }) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.article
      className="specs-placeholder surface-1"
      aria-live="polite"
      aria-label={readMessage(
        messages,
        'specs.emptyAria',
        'No specifications available',
      )}
      variants={prefersReducedMotion ? undefined : panelVariants}
      initial={prefersReducedMotion ? false : 'hidden'}
      animate={prefersReducedMotion ? undefined : 'visible'}
    >
      <motion.div
        className="specs-placeholder-inner"
        variants={prefersReducedMotion ? undefined : staggerContainer}
        initial={prefersReducedMotion ? false : 'hidden'}
        animate={prefersReducedMotion ? undefined : 'visible'}
      >
        <motion.div
          className="specs-placeholder-media"
          variants={prefersReducedMotion ? undefined : specRowVariants}
          custom={0}
        >
          <IllustrationMotion
            src="/images/searchEmpty.jpg"
            alt={readMessage(
              messages,
              'specs.placeholderAlt',
              'Illustration for upcoming product specifications',
            )}
            maxHeight={190}
            tone='info'
            className="specs-placeholder-illustration"
          />
        </motion.div>

        <motion.div
          className="specs-placeholder-content"
          variants={prefersReducedMotion ? undefined : specRowVariants}
          custom={1}
        >
          <p className="product-detail-panel__eyebrow specs-placeholder__eyebrow">
            {readMessage(messages, 'specs.title', 'Specifications')}
          </p>
          <h2 className="specs-placeholder__title">
            {readMessage(messages, 'specs.noSpecs', 'No specs available yet')}
          </h2>
          <p className="placeholder-text">
            {readMessage(
              messages,
              'specs.placeholder',
              'Product highlights coming soon',
            )}
          </p>
        </motion.div>
      </motion.div>
    </motion.article>
  );
}
